module.exports = __webpack_public_path__ + "media/fallback/smiling-female-0403996b.jpg";